module.exports = __webpack_public_path__ + "static/turtle-creek-house03-161729662a7b4450cab531c8a4a54b15.jpg";